var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33334 3.65877C1.33334 2.92239 1.9303 2.32544 2.66668 2.32544H16C16.3536 2.32544 16.6928 2.46592 16.9428 2.71596L27.3962 13.1693C27.9169 13.69 27.9169 14.5342 27.3962 15.0549C26.8755 15.5756 26.0312 15.5756 25.5105 15.0549L15.4477 4.99211H4.00001V16.4398L15.9962 28.436C16.7288 29.1686 17.9379 29.1686 18.6705 28.436L19.4305 27.676C19.9512 27.1553 20.7955 27.1553 21.3161 27.676C21.8368 28.1967 21.8369 29.0409 21.3162 29.5616L20.5562 30.3216C18.7821 32.0956 15.8846 32.0956 14.1105 30.3216L1.72387 17.9349C1.47382 17.6849 1.33334 17.3457 1.33334 16.9921V3.65877Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.3255C8 9.58914 8.59695 8.99219 9.33333 8.99219H9.34667C10.083 8.99219 10.68 9.58914 10.68 10.3255C10.68 11.0619 10.083 11.6589 9.34667 11.6589H9.33333C8.59695 11.6589 8 11.0619 8 10.3255Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2761 18.4093C30.7968 18.93 30.7968 19.7742 30.2761 20.2949L24.9428 25.6283C24.4221 26.149 23.5779 26.149 23.0572 25.6283L20.3905 22.9616C19.8698 22.4409 19.8698 21.5967 20.3905 21.076C20.9112 20.5553 21.7554 20.5553 22.2761 21.076L24 22.7998L28.3905 18.4093C28.9112 17.8886 29.7554 17.8886 30.2761 18.4093Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagCheck);
export default __webpack_public_path__ + "static/media/tag_check.428fdf82655767dfe2c75f86000811c4.svg";
export { ForwardRef as ReactComponent };